import { occFetch, occUrl } from "~/app/api/occ/occFetch";
import { type QuoteDetailsDTO } from "~/features/orders/quoteList/api/fetchOrderDetails/dto";

// soNumber === salesDocument
export async function fetchQuoteDetails(
  soNumber: string,
  accountNumber?: string,
  salesOrg?: string,
): Promise<QuoteDetailsDTO> {
  let url = occUrl(`/quotes/${encodeURIComponent(soNumber)}`);

  if (accountNumber && salesOrg) {
    const params = new URLSearchParams();
    params.append("soldTo", accountNumber);
    params.append("salesOrg", salesOrg);
    url = url + "?" + params.toString();
  }

  const response = await occFetch(url);
  if (!response.ok) {
    throw new Error(`Unable to load quote details: ${response.status}`);
  }
  return (await response.json()) as QuoteDetailsDTO;
}
